import { render, staticRenderFns } from "./MgaBillingManager.vue?vue&type=template&id=5919a5f2&scoped=true"
import script from "./MgaBillingManager.vue?vue&type=script&lang=js"
export * from "./MgaBillingManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5919a5f2",
  null
  
)

export default component.exports